import { render, staticRenderFns } from "./MoreDropdown.vue?vue&type=template&id=aa77856e"
import script from "./MoreDropdown.vue?vue&type=script&lang=ts"
export * from "./MoreDropdown.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports